<template>
  <section class="webinar-testimonials">
    <v-container>
      <div class="row">
        <div class="col-12">
          <rwl-heading h="2"
                       align="center"
                       class="webinar-testimonials__title">
            <slot name="title"></slot>
          </rwl-heading>
        </div>
        <div class="col-8 offset-2 webinar-testimonials__description">
          <slot name="description"></slot>
        </div>
      </div>

      <div class="row testimonials-list">
        <testimonials-item v-for="item in items"
                           :key="item.title"
                           :class="item.classes"
                           :title="item.title"
                           :description="item.description"
                           :icon="item.icon"
        ></testimonials-item>
      </div>

      <div class="row">
        <div class="col-12 col-sm-10 offset-sm-1">
          <testimonials-slider
            class="testimonials-slider"
            :show-decoration-triangle="true"
            :testimonials="testimonials"></testimonials-slider>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
  import {
    TestimonialsSlider,
    Testimonial
  } from "./testimonials/TestimonialsSlider"
  import {
    RwlHeading,
  } from "@rawlplug/rawlplug-design-components-library";
  import { TestimonialsItem } from "./testimonials/index"
  import { IconSunWatch, IconMac, VContainer, IconFiles, IconSee } from "./ui/index"

  export default {
    name: "WebinarTestimonials",
    data() {
      return {
        items: [
          {
            icon: null,
            title: this.$t('webinars.testimonial_1_title'),
            description: this.$t('webinars.testimonial_1_description'),
            classes: `col-12 col-sm-4 testimonials-item--get-experience`,
          },
          {
            icon: IconFiles,
            title: this.$t('webinars.testimonial_2_title'),
            description: this.$t('webinars.testimonial_2_description'),
            classes: `col-12 col-sm-4`
          },
          {
            icon: IconSee,
            title: this.$t('webinars.testimonial_3_title'),
            description: this.$t('webinars.testimonial_3_description'),
            classes: `col-12 col-sm-4`
          }
        ],
        testimonials: [
          new Testimonial(
            "Webinars for me are very important as the live demonstrations shows real-time proof of quality and strength. Also talking to a person or persons creating Q&A possibilities, eliminates important info being lost in translation",
            "Werner Pretorius",
            "Vermont, South Africa"
          ),
          new Testimonial(
            "Great experience overall. Relevant information provided in a good timeframe, well dozed by the professional team.  Rawlplug Academy training helped me improve my knowledge on the portfolio and  gave me confidence that we’ll be able to offer specific solution to our customers’ needs.",
            "George Joitoiu",
            "Baltic Invest, Romania"
          ),
          new Testimonial(
            "I think that webinar is very useful for us to refresh and update more about product knowledge. I hope that you will do it for our customers in Vietnam next time as well.",
            "Nguyen The Dung",
            "HHK, Vietnam"
          )
        ]
      }
    },
    components: {
      VContainer,
      RwlHeading,
      TestimonialsItem,
      TestimonialsSlider,
    }
  }
</script>

<style lang="scss" scoped>
  .webinar-testimonials {
    padding: $section-padding;

    &__title {
      text-align: center;
    }

    &__description {
      padding: $spacing-5 0 $spacing-8;

      p {
        margin: 0;
        padding: 0;
      }
    }

    .testimonials-item--get-experience {
      background-color: $color-rwl-gray-15;
      position: relative;
      $size: 50px;
      margin-bottom: $size;
      text-align: center;

      &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        left: 50%;
        transform: translateX(-100%);
        bottom: -$size;

        border-style: solid;
        border-width: 0 $size $size 0;
        border-color: transparent $color-rwl-gray-15 transparent transparent;
      }
    }

    .testimonials-slider {
      margin-bottom: 0;
    }

    @media (max-width: $breakpoint-xs-max) {
      .testimonials-item--get-experience {
        order: 3;
      }

      .testimonials-slider.with-decoration-triangle {
        &:after {
          left: 50%;
          transform: translateX(-50%);
        }
      }

      .testimonials-item--get-experience {
        &:after {
          transform: translateX(-150%);
        }
      }
    }
  }

</style>
